import { useState } from "react";
import { enableDistrict, disableDistrict } from "@features/district/api/districtApi";

/**
 * Hook exposing district enable/disable actions and a busy flag.
 */
export function useDistrictActions() {
    const [busy, setBusy] = useState(false);

    const doDistrictDisable = async (nationId: number, districtId: number) => {
        setBusy(true);
        const response = await disableDistrict(nationId, districtId);
        setBusy(false);
        return response;
    };

    const doDistrictEnable = async (nationId: number, districtId: number) => {
        setBusy(true);
        const response = await enableDistrict(nationId, districtId);
        setBusy(false);
        return response;
    };

    return { busy, doDistrictDisable, doDistrictEnable };
}
